import { useEffect, useRef } from 'react';

/**
 *  Custom hook to prevent state update on unmounted component
 *
 * @returns didMountRef which could be use in async / state updated fn to
 * prevent updating in case if component has been unmounted.
 *
 * Usage:
 *          const didMount = useIsMounted();
 *          if (didMount.current) setState(stateUpdate);
 *
 */
export function useIsMounted() {
	const didMountRef = useRef(true);

	useEffect(() => {
		didMountRef.current = true;
		return () => void (didMountRef.current = false);
	}, []);
	return didMountRef;
}
